(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["swiper-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('swiper-media-gallery')) {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  const trapFocusHandlers = {};

  function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      )
        return;

      document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function() {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function(event) {
      if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
      // On the last focusable element and tab forward, focus the first element.
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }

      //  On the first focusable element and tab backward, focus the last element.
      if (
        (event.target === container || event.target === first) &&
        event.shiftKey
      ) {
        event.preventDefault();
        last.focus();
      }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
  }



  function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }



  function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
  }



  customElements.define('swiper-media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="swiper--"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        swiperThumbnails: document.querySelector('#swiper--thumbnail'),
        swiperMedia: document.querySelector('#swiper--main-media'),
        swiperPopup: document.querySelector('#swiper--popup'),
        modalDialog: document.querySelector('modal-dialog'),
        variantPicker: document.querySelector('variant-picker'),
      }
      this.updatem();
      window.addEventListener('resize', this.updatem());

      
      if(!this.elements.swiperMedia.swiper){
        const swiperThumbnails = new Swiper(this.elements.swiperThumbnails, {
          spaceBetween: 12,
          direction: "vertical",
          navigation: {
            watchSlidesProgress: true,
          },
        });
        const swiperMedia = new Swiper(this.elements.swiperMedia, {
            spaceBetween: 0,
            mousewheel: true,
            thumbs: {
                swiper: swiperThumbnails,
            }
        });
        const swiperPopup = new Swiper(this.elements.swiperPopup, {
          spaceBetween: 0,
            thumbs: {
              swiper: swiperMedia,
            },
          navigation: {
            nextEl: "#button--next-media",
            prevEl: "#button--prev-media",
            watchSlidesProgress: true,
            addIcons:false,
          }
        });


        this.elements.modalDialog.querySelector('.product-media-modal__toggle').addEventListener('click', (event) => {
          this.hide();
          if (event.target === this) this.show();
        });
      }
      this.setSwiper();

    }
    setSwiper() {
      if (!this.elements.variantPicker) return;
      const targetIndex = Number(this.elements.variantPicker.querySelector('input:checked').dataset.mediaId)-1;
      this.elements.swiperMedia.swiper.slideTo(targetIndex, 600);
      // this.elements.swiperPopup.swiper.slideTo(targetIndex, 600);
    }

      updatem() {
        // console.dir(this.elements.variantPicker.querySelector('input:checked').dataset.mediaId);
        
        const width = window.innerWidth;
        if (width >= 750) {
          // console.dir(this.elements.swiperMedia);
          this.elements.swiperMedia.addEventListener('click', (event) => {
            console.dir(event.target);
            this.show();
            if (event.target === this) this.show();
          });
        } else {
          console.dir(width);
          document.querySelectorAll('.product__media-toggle').forEach((element) => {
            element.addEventListener('click', (event) => {
              this.show();
            });
          });
        }
      }

    show() {
      this.elements.modalDialog.classList.add('show');
      console.dir(this.elements.swiperMedia.offsetWidth);
    }

    hide() {
      this.elements.modalDialog.classList.remove('show');
    }

    onSlideChanged(event) {
      console.dir(this.elements);
      const slideIndex = this.elements.swiperThumbnails.swiper.realIndex;
      this.elements.swiperMedia.swiper.slideTo(slideIndex);
    }
    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      // this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
